import BasePage from "../modules/basePage";
import goToURL from "../modules/helpers/goToURL";
import { trackEvent } from "../modules/track";
import { updateQueryStringParameter, getParameterByName } from "../modules/urlUtils";

class SearchPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        const self = this;
        super.onReady();
        self.searchBtnListener();
    }

    onLoad() {
        document.getElementById("search").value = getParameterByName("q", window.location.href);
        const query = document.getElementById("search").value;
        const totalResults = document.getElementById("searchResults").getAttribute("data-searchResults");
        trackEvent({
            event: "search",
            search_term: query,
            results: totalResults,
            interaction_type: "search"
        });
    }

    searchBtnListener() {
        const self = this;
        const searchButton = document.querySelector(".searchButton");
        const searchInput = document.getElementById("search");
        if (searchButton) {
            searchButton.addEventListener("click", self.submitSearch);
            searchInput.addEventListener("keyup", function (event) {
                if (event.keyCode === 13) {
                    self.submitSearch();
                }
            });
        }
    }
    submitSearch() {
        const query = document.getElementById("search").value;
        if (query) {
            const url = updateQueryStringParameter(window.location.href, "q", query);
            goToURL(url);
        }
    }
}

new SearchPage();
